import { getOrganizationInfo,getAgreeAllCompany, sysDic } from '@/api/httpList'
import http from '@/api/http.js' //ajax请求
export const actions = {
  //获取机构信息
  setMechOranization(context, playload) {
    const searchObj = {}
    searchObj.organizationId = playload.id
    if (playload.status) {
      searchObj.status = playload.status
    }
    getOrganizationInfo(searchObj).then(res => {
      context.commit("setMechOranization", res.data);
      if (playload.callback) playload.callback()
    })
  },
  //获取所有公司名称
  getCompanyList({ state }) {
    if (state.companyList.length) {
      return;
    }
    http({
      url: "/buz/insuranceCompany/getCompanies",
      type: "get",
    }).then(res => {
      state.companyList = res.data;
    })
  },
  //获取所有产品分类
  getThemeList({ state }) {
    if (state.themeList.length) {
      return;
    }
    http({
      url: "/buz/productTheme/array/first",
      type: "get",
    }).then(res => {
      state.themeList = res.data;
    })
  },
  //获取所有公司名称 线下
  getCompanyListEntity({ state }) {
    if (state.companyListEntity.length) {
      return;
    }
    http({
      url: "/buz/molInsuranceCompany/read/companies",
      type: "get",
    }).then(res => {
      state.companyListEntity = res.data;
    })
  },
  //获取所有产品分类 线下
  getThemeListEntity({ state }) {
    if (state.themeListEntity.length) {
      return;
    }
    http({
      url: "/buz/molProductTheme/read/themes",
      type: "get",
    }).then(res => {
      state.themeListEntity = res.data;
    })
  },
  //协议管理获取所有保险公司
  getAllAgreeCompany(context) {
    getAgreeAllCompany().then(res=>{
      context.commit("setAllAgreeCompany", res.data);
    })
  },
  // 产品库-费用档次-新增-获取影响因子列表
  getYxyzList(context){
    sysDic({type:'AFFECT_TYPE'}).then(res=>{
      context.commit("setYxyzList", res.data);
    })
  },
  // 地区数据
  getRegion({ state }) {
    if(state.regionsArr&&state.regionsArr.length){
      return state.regionsArr;
    }
    return http({
      url: "/json/region.json",
      type: "GET",
      forced: true,
      data: {},
    }).then((region) => {
      state.regionsArr = region;
      return state.regionsArr
    });
  },
}
